import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHubAssignFailed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 140,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 89.6406,
			cy: 120.66,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40.6406,
			cy: 35.6602,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.613 22.6772C72.613 20.052 74.5563 17.8323 77.1585 17.4853L91.5945 15.5605C97.2 14.8132 102.88 14.8132 108.485 15.5605L123.305 17.5365C125.737 17.8608 127.618 19.8301 127.831 22.2746L131.993 70.1394C132.63 77.4672 132.357 84.8457 131.179 92.1062L128.18 110.601C127.769 113.137 125.579 115 123.01 115H77.8507C74.958 115 72.613 112.655 72.613 109.762V22.6772Z",
			fill: "url(#paint0_linear_8280_31016)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M127.715 22.6772C127.715 20.052 125.771 17.8323 123.169 17.4853L108.733 15.5605C103.128 14.8132 97.4477 14.8132 91.8422 15.5605L77.0228 17.5365C74.5906 17.8608 72.7095 19.8301 72.4969 22.2746L68.3347 70.1394C67.6976 77.4672 67.9708 84.8457 69.1482 92.1062L72.1472 110.601C72.5585 113.137 74.7484 115 77.3175 115H122.477C125.37 115 127.715 112.655 127.715 109.762V22.6772Z",
			fill: "url(#paint1_linear_8280_31016)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 80.0469,
			y: 24.4277,
			width: 40.2262,
			height: 53.0255,
			rx: 1,
			fill: "url(#paint2_linear_8280_31016)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 94,
			cy: 84,
			r: 2,
			fill: "url(#paint3_linear_8280_31016)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 100,
			cy: 84,
			r: 2,
			fill: "url(#paint4_linear_8280_31016)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 97,
			cy: 89,
			r: 2,
			fill: "url(#paint5_linear_8280_31016)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 103,
			cy: 89,
			r: 2,
			fill: "url(#paint6_linear_8280_31016)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 106,
			cy: 84,
			r: 2,
			fill: "url(#paint7_linear_8280_31016)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 100,
			cy: 20,
			r: 2,
			fill: "url(#paint8_linear_8280_31016)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M145.333 69.9998C145.333 77.3636 139.363 83.3332 131.999 83.3332C124.636 83.3332 118.666 77.3636 118.666 69.9998C118.666 62.636 124.636 56.6665 131.999 56.6665C139.363 56.6665 145.333 62.636 145.333 69.9998Z",
			fill: "#DB5543",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M132 62.3335C132.552 62.3335 133 62.7812 133 63.3335V71.3335C133 71.8858 132.552 72.3335 132 72.3335C131.448 72.3335 131 71.8858 131 71.3335V63.3335C131 62.7812 131.448 62.3335 132 62.3335ZM132 74.3335C132.552 74.3335 133 74.7812 133 75.3335V76.6668C133 77.2191 132.552 77.6668 132 77.6668C131.448 77.6668 131 77.2191 131 76.6668V75.3335C131 74.7812 131.448 74.3335 132 74.3335Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_8280_31016",
				x1: 70.4532,
				y1: 20.0847,
				x2: 151.747,
				y2: 72.8768,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_8280_31016",
				x1: 70.4532,
				y1: 20.0847,
				x2: 151.747,
				y2: 72.8768,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_8280_31016",
				x1: 100.16,
				y1: 24.4277,
				x2: 100.16,
				y2: 77.4532,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_8280_31016",
				x1: 94,
				y1: 82,
				x2: 94,
				y2: 86,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#80E8D6"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_8280_31016",
				x1: 100,
				y1: 82,
				x2: 100,
				y2: 86,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#80E8D6"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_8280_31016",
				x1: 97,
				y1: 87,
				x2: 97,
				y2: 91,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#80E8D6"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_8280_31016",
				x1: 103,
				y1: 87,
				x2: 103,
				y2: 91,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#80E8D6"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_8280_31016",
				x1: 106,
				y1: 82,
				x2: 106,
				y2: 86,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#80E8D6"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint8_linear_8280_31016",
				x1: 100,
				y1: 18,
				x2: 100,
				y2: 22,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#80E8D6"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgHubAssignFailed);
export { ForwardRef as ReactComponent };
